"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * The action to update the flags behind the checkboxes in the txp options UI
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('updateTxpFlag')(function updateTxpFlag(flagName, enabled, state) {
    var optionState = state.optionState;
    if (flagName == 'EventsFromEmailEnabled' || flagName == 'CreateEventsFromEmailAsPrivate') {
        optionState[flagName] = enabled;
    }
    else {
        optionState.Events[flagName] = enabled;
    }
}));
//# sourceMappingURL=updateTxpFlag.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-txp-option/lib/actions/updateTxpFlag.js
// module id = 3768
// module chunks = 2